var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0003 3.14966C35.2742 3.14966 44.4171 12.2925 44.4171 23.5665C44.4171 34.8404 35.2742 43.9832 24.0003 43.9832C12.7264 43.9832 3.5835 34.8404 3.5835 23.5665C3.5835 12.2925 12.7264 3.14966 24.0003 3.14966ZM21.813 25.3233V14.8151C21.813 13.6104 22.7956 12.6277 24.0003 12.6277C25.205 12.6277 26.1876 13.6195 26.1876 14.8151V25.3233C26.1876 26.5189 25.2049 27.5107 24.0003 27.5107C22.7956 27.5107 21.813 26.528 21.813 25.3233ZM23.9908 29.8566C25.3598 29.8566 26.4701 30.9669 26.4701 32.3357C26.4701 33.7047 25.3598 34.815 23.9908 34.815C22.622 34.815 21.5117 33.7047 21.5117 32.3357C21.5117 30.9669 22.622 29.8566 23.9908 29.8566Z",
    fill: "#EC2D30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.3cd5b928199895fff8681a84f8e25821.svg";
export { ForwardRef as ReactComponent };